import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Snapshot of a fully-rendered InstallationProfile pushed to an installation.
 *
 * `renderedProfileJson` carries the complete render output (openclaw.json,
 * workspaceFiles, credentials) at publish time. Treated as opaque JSON here
 * — the renderer schema (in @fm/api) is the source of truth for its shape.
 *
 * @since 1.0.0
 */
export class InstallationProfilePublish extends Model.Class<InstallationProfilePublish>("InstallationProfilePublish")({
  id: Model.Generated(Schema.String),
  installationId: Schema.String,
  version: Schema.Number,
  renderedProfileJson: Schema.Unknown,
  publishedBy: Schema.NullOr(Schema.String),
  publishedAt: Model.DateTimeInsertFromDate,
  isCurrent: Schema.Boolean,
}) {}
